<template>
    <div class="offcanvas-saved" :class="{'offcanvas-saved--enter': showSaveCompare, 'offcanvas-saved--leave': !showSaveCompare}">
        <a v-if="admin" href="/my-account/saved-vehicles" class="offcanvas-saved__link" target="_blank">
            <div class="offcanvas-saved__item">Saved</div>
            <div class="offcanvas-saved__item offcanvas-saved__item--heart"><svg class="offcanvas-saved__heart-svg" width="32" height="29" viewBox="0 0 32 29" xmlns="http://www.w3.org/2000/svg"><g class="offcanvas-saved--heart-inner"><path d="M31 9.2C31 4.7 27.4 1.1 22.9 1.1 20 1.1 17.4 2.7 16 5 14.6 2.7 12 1.1 9.1 1.1 4.6 1.1 1 4.7 1 9.2 1 11.6 2.1 13.8 3.8 15.3L15.3 26.8C15.5 27 15.7 27.1 16 27.1 16.3 27.1 16.5 27 16.7 26.8L28.2 15.3C29.9 13.8 31 11.6 31 9.2Z"/></g></svg><div class="offcanvas-saved__heart-count">{{ compareCount }}</div></div>
        </a>
        <router-link v-else :to="compareLink" class="offcanvas-saved__link">
            <div class="offcanvas-saved__item">Saved</div>
            <div class="offcanvas-saved__item offcanvas-saved__item--heart"><svg class="offcanvas-saved__heart-svg" width="32" height="29" viewBox="0 0 32 29" xmlns="http://www.w3.org/2000/svg"><g class="offcanvas-saved--heart-inner"><path d="M31 9.2C31 4.7 27.4 1.1 22.9 1.1 20 1.1 17.4 2.7 16 5 14.6 2.7 12 1.1 9.1 1.1 4.6 1.1 1 4.7 1 9.2 1 11.6 2.1 13.8 3.8 15.3L15.3 26.8C15.5 27 15.7 27.1 16 27.1 16.3 27.1 16.5 27 16.7 26.8L28.2 15.3C29.9 13.8 31 11.6 31 9.2Z"/></g></svg><div class="offcanvas-saved__heart-count">{{ compareCount }}</div></div>
        </router-link>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import numberFormat from '../api/NumberFormat';

export default {
    components: {
    },
    data() {
        return {
        };
    },
    computed: {
        ...mapGetters({
            compareCount: "Layout/compareCount",
            compareLink: "Layout/compareLink",
        }),
        ...mapState("Layout", ['admin']),
        countFormatted: {
            get() {
                return numberFormat(this.compareCount);
            },
        },
        showSaveCompare() {
            return (this.$store.state.Layout.showSaveCompare && this.compareCount > 0) ? true : false;
        },
    },
}
</script>

<style lang="scss">
@import "../../../sass/redesign/variables";

.offcanvas-saved {
    position: fixed;
    bottom: 0;
    left: 0;
    opacity: 0.8;
    transform: translateY(100%);
    z-index: 200;
    padding: 10px;
    margin: 0 0 0 10px;

    &:hover {
        text-decoration: none;
    }

    &--enter {
        opacity: 1;
        transform: translateY(0);
        transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
    }

    &--leave {
        opacity: 0.8;
        transform: translateY(100%);
        transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
    }

    &__link {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 10px;
        background-color: #ffffff;
        border-radius: 10px 10px 0 0;
    }

    &__item {
        position: relative;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: 1fr;

        &:hover {
            text-decoration: underline;
            text-decoration-color: $blue;
            text-underline-offset: 4px;
            text-decoration-thickness: 3px;
        }
        &--heart {
            &:hover {
                text-decoration: none;
            }
        }
    }


    &__heart-count {
        grid-area: 1 / 1 / 2 / 2;
        font-size: 14px;
        color: #ffffff;
        font-weight: 700;
        align-self: center;
        justify-self: center;

        &:hover {
            text-decoration: none;
        }
    }

    &__heart-svg {
        grid-area: 1 / 1 / 2 / 2;
        width: 28px;
        height: 28px;
        fill: $blue;
    }
}
</style>
